<template>
  <div class="image-uploader">
    <div class="image-uploader_card">
      <div v-if="status === 'empty'" class="uploader-empty" @click="triggerFileInput">
        <div class="uploader-plus"><img class="fit-img" src="@/common/images/student/ic_upload.png"/></div>
        <div class="uploader-text">上传图片</div>
      </div>
      <div v-else-if="status === 'uploading'" class="uploader-uploading">
        <div class="uploader-loading"><img class="fit-img" src="@/common/images/student/ic_upload_loading.png"/></div>
        <div class="uploader-text">正在上传</div>
      </div>
      <div v-else-if="status === 'success'" class="uploader-success" @click="handlePreview">
        <img :src="value" class="uploader-img" />
        <div class="uploader-close" @click.stop="removeImage"><img class="fit-img" src="@/common/images/student/ic_upload_delete.png"/></div>
      </div>
      <div v-else-if="status === 'error'" class="uploader-error">
        <div class="uploader-error-icon"><img class="fit-img" src="@/common/images/student/ic_upload_error.png"/></div>
        <div class="uploader-text">上传失败</div>
      </div>
      <input ref="fileInput" type="file" accept="image/jpeg,image/png,image/jpg" style="display:none" @change="onFileChange" />
    </div>
    <div v-if="showRetry" class="uploader-retry" @click.stop="triggerFileInput">重新上传</div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="value" alt="">
    </el-dialog>
  </div>
</template>
<script>
import { getAuth,fetch } from '@/common/js/fetch';
import { serverCourseUrl } from '@/api/api';
import { Dialog } from 'element-ui';

export default {
  name: 'ImageUploader',
  components: {
    'el-dialog': Dialog,
  },
  props: {
    value: String,
  },
  data() {
    return {
      status: this.value ? 'success' : 'empty',
      uploadUrl: `${serverCourseUrl}v1/resource/upload`,
      dialogVisible: false,
    };
  },
  watch: {
    value(val) {
      this.status = val ? 'success' : 'empty';
    }
  },
  computed: {
    showRetry() {
      return ['error', 'success'].includes(this.status);
    }
  },
  methods: {
    triggerFileInput() {
      if (this.status === 'uploading') return;
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      // const isImage = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type);
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message && this.$message.error ? this.$message.error('请上传jpeg或者png格式图片') : alert('请上传jpeg或者png格式图片');
        return;
      }
      this.status = 'uploading';
      this.uploadFile(file);
    },
    uploadFile(file) {
      const formData = new FormData();
      formData.append('resourceFile', file);
      fetch(this.uploadUrl, {},{
        method: 'POST',
        body: formData,
      })
        .then(async res => {
          if (res?.body?.resourceUrl) {
            this.status = 'success';
            this.$emit('input', res.body.resourceUrl);
          } else {
            this.status = 'error';
          }
        })
        .catch(() => {
          this.status = 'error';
        });
    },
    removeImage() {
      this.status = 'empty';
      this.$emit('input', '');
    },
    handlePreview() {
      this.dialogVisible = true;
    }
  }
}
</script>

<style lang="less" scoped>
.image-uploader {
  &_card {
    width: 128px;
    height: 128px;
    border: 1px dashed #CED4DB;
    // border-radius: 6px;
    background: #F5F7FA;
    position: relative;
    cursor: pointer;
    &:hover {
      border-color: #409EFF;
      background: #EEF1F5;
    }
    .uploader-plus {
      width: 32px;
      height: 32px;
    }
    .uploader-text {
      font-size: 12px;
      color: #8D9094;
      margin-top: 8px;
    }
    .uploader-loading {
      width: 32px;
      height: 32px;
      animation: spin 1s linear infinite;
      margin: 0 auto;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    .uploader-empty, .uploader-success, .uploader-error, .uploader-uploading {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      box-sizing: border-box;
    }
    .uploader-success {
      padding: 9px;
      .uploader-img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 6px;
      }
      .uploader-close {
        position: absolute;
        top: -14px;
        right: -14px;
        cursor: pointer;
        width: 28px;
        height: 28px;
      }

    }
    .uploader-error {
      .uploader-error-icon {
        width: 32px;
        height: 32px;
      }
      .uploader-retry {
        color: #3491FA;
        font-size: 14px;
        margin-top: 8px;
        cursor: pointer;
        text-align: center;
      }
    }
  }
  .uploader-retry {
    color: #3491FA;
    font-size: 14px;
    margin-top: 8px;
    cursor: pointer;
    text-align: center;
  }
}
</style>